// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}
/* ===== GLOBAL SCROLLBAR ===== */

/* Chrome, Edge, Safari */
*::-webkit-scrollbar {
  width: 2px;      /* vertical */
  height: 2px;     /* horizontal */
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #f59255;
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #f59255;
}

/* Hide arrows */
*::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ck-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.ck-modal {
  width: 100%;
  max-width: 400px;
  background: #111;
  border: 2px solid #f59255;
  border-radius: 14px;
  padding: 22px;
  color: white;
}

.ck-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -4px;
  font-size: 20px;
  font-weight: 700;
}

.ck-form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ck-form-fields > div {
  display: flex;
  flex-direction: column;
}

.ck-input {
  width: 100%;
  margin: 0;
  padding: 10px;
  background: #161616;
  border: 1px solid #444;
  border-radius: 6px;
  color: white;
  box-sizing: border-box;
}

.ck-input-toggle {
  padding-right: 46px;
}

.ck-input:focus {
  border-color: #fff;
  outline: none;
}

.ck-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.ck-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: #f59255;
  cursor: pointer;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 32px;
  height: 32px;
}

.ck-btn {
  width: 100%;
  padding: 12px 0;
  background: transparent;
  color: #f59255;
  border: 2px solid #f59255;
  border-radius: 8px;
  margin-top: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.ck-btn1 {
  padding: 12px 0;
  background: transparent;
  color: #f59255;
  border: 2px solid #f59255;
  border-radius: 8px;
  margin-top: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 20px;
}

.ck-btn1:hover:not(:disabled) {
  background: #f59255;
  color: #111;
}

.ck-btn:hover:not(:disabled) {
  background: #f59255;
  color: #111;
}

.ck-close {
  background: transparent;
  border: none;
  color: #bcbcbc;
  font-size: 20px;
  cursor: pointer;
  margin-right: 10px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.ck-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #e0e0e0;
}

.ck-switch {
  font-size: 14px;
  color: #f59255;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  text-decoration: underline;
  font-weight: 500;
}

.ck-switch:hover {
  color: #f59255;
}

.ck-switch-divider {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #333;
  text-align: center;
  font-size: 14px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.ck-error {
  background: transparent;
  color: #ff3737;
  padding: 0;
  margin-bottom: 10px;
  border-radius: 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ck-error::before {
  content: "*";
  color: #ff3737;
}
/* ===== GLOBAL MODAL BACKDROP ===== */
.ck-global-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 1000;
}

/* Modal itself */
.ck-modal {
  position: fixed;
  z-index: 1001;
}

/* 🔥 HACK: Overwriting Tailwind's bg-black globally without touching components 🔥 */
.bg-black {
  background-color: #0b0b0b !important;
}

/* Optional: Agar koi section pure black #000 use kar raha hai inline style mein */
section {
  background-color: #0b0b0b !important;
}

body, 
#root, 
.bg-black, 
[class*="bg-black"], 
section, 
footer {
  background-color: #0b0b0b !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA,iCAAiC;;AAEjC,yBAAyB;AACzB;EACE,UAAU,OAAO,aAAa;EAC9B,WAAW,MAAM,eAAe;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,aAAa;AACf;;AAEA,qFAAqF;AACrF;EACE,oCAAoC;AACtC;;AAEA,kFAAkF;AAClF;EACE,oCAAoC;AACtC;;AAEA;;;;;;EAME,oCAAoC;AACtC","sourcesContent":[".App {\n  text-align: center;\n}\n/* ===== GLOBAL SCROLLBAR ===== */\n\n/* Chrome, Edge, Safari */\n*::-webkit-scrollbar {\n  width: 2px;      /* vertical */\n  height: 2px;     /* horizontal */\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #f59255;\n  border-radius: 4px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #f59255;\n}\n\n/* Hide arrows */\n*::-webkit-scrollbar-button {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ck-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.ck-modal {\n  width: 100%;\n  max-width: 400px;\n  background: #111;\n  border: 2px solid #f59255;\n  border-radius: 14px;\n  padding: 22px;\n  color: white;\n}\n\n.ck-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: -4px;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.ck-form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ck-form-fields > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.ck-input {\n  width: 100%;\n  margin: 0;\n  padding: 10px;\n  background: #161616;\n  border: 1px solid #444;\n  border-radius: 6px;\n  color: white;\n  box-sizing: border-box;\n}\n\n.ck-input-toggle {\n  padding-right: 46px;\n}\n\n.ck-input:focus {\n  border-color: #fff;\n  outline: none;\n}\n\n.ck-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ck-toggle {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  color: #f59255;\n  cursor: pointer;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n}\n\n.ck-btn {\n  width: 100%;\n  padding: 12px 0;\n  background: transparent;\n  color: #f59255;\n  border: 2px solid #f59255;\n  border-radius: 8px;\n  margin-top: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.ck-btn1 {\n  padding: 12px 0;\n  background: transparent;\n  color: #f59255;\n  border: 2px solid #f59255;\n  border-radius: 8px;\n  margin-top: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 20px;\n}\n\n.ck-btn1:hover:not(:disabled) {\n  background: #f59255;\n  color: #111;\n}\n\n.ck-btn:hover:not(:disabled) {\n  background: #f59255;\n  color: #111;\n}\n\n.ck-close {\n  background: transparent;\n  border: none;\n  color: #bcbcbc;\n  font-size: 20px;\n  cursor: pointer;\n  margin-right: 10px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.ck-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #e0e0e0;\n}\n\n.ck-switch {\n  font-size: 14px;\n  color: #f59255;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 4px;\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.ck-switch:hover {\n  color: #f59255;\n}\n\n.ck-switch-divider {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #333;\n  text-align: center;\n  font-size: 14px;\n  color: #999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.ck-error {\n  background: transparent;\n  color: #ff3737;\n  padding: 0;\n  margin-bottom: 10px;\n  border-radius: 0;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ck-error::before {\n  content: \"*\";\n  color: #ff3737;\n}\n/* ===== GLOBAL MODAL BACKDROP ===== */\n.ck-global-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  z-index: 1000;\n}\n\n/* Modal itself */\n.ck-modal {\n  position: fixed;\n  z-index: 1001;\n}\n\n/* 🔥 HACK: Overwriting Tailwind's bg-black globally without touching components 🔥 */\n.bg-black {\n  background-color: #0b0b0b !important;\n}\n\n/* Optional: Agar koi section pure black #000 use kar raha hai inline style mein */\nsection {\n  background-color: #0b0b0b !important;\n}\n\nbody, \n#root, \n.bg-black, \n[class*=\"bg-black\"], \nsection, \nfooter {\n  background-color: #0b0b0b !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
